import { planetPosition } from "./config";

export const getPlantPosition = (data: any) => {
  return data?.map((item: any, index: any) => {
    const selectedIndex: number[] = [];


  //   const modifiedPlanets = item.planet.map((obj: any, levelindex: any) => {
  //     console.log(levelindex,'levelindex')
      
  //     let randomIndex;
      
  //     if (index === 1 || index === 2) {
  //       randomIndex = Math.floor(Math.random() * 8);
  //     } else {
  //       randomIndex = Math.floor(Math.random() * 6);
  //     }
  //     while (selectedIndex.includes(randomIndex)) {
  //       randomIndex = Math.floor(Math.random() * (index === 1 || index === 2 ? 8 : 6));
  //     }
  //     selectedIndex.push(randomIndex);
  //     const position =
  // planetPosition[index] && planetPosition[index][randomIndex];

  //      const mergedObject = position
  // ? { ...obj, ...position }
  // : obj;

  //     // const mergedObject = { ...obj, ...planetPosition[index][randomIndex] };
  //     console.log(mergedObject,index,randomIndex)
  //     return mergedObject;
  //   });

    const modifiedPlanets: any[] = [];
    const total = item.planet.length;

    item.planet.forEach((obj: any, levelindex: number) => {
      let position;

      // ===== Special logic for index 0 (first stage) =====
      if (index === 0) {
        if (levelindex < 5) {
          // first 5 planets → normal positions
          modifiedPlanets.push({
            ...obj,
            ...planetPosition[0][levelindex],
          });
        } 
        else if (levelindex === 5) {
          // 6th planet → bucket if overflow, else normal
          if (total > 6) {
            modifiedPlanets.push({
              ...obj,
              ...planetPosition[0][5],
              children: [obj],
            });
          } else {
            // remove any pre-existing children if length === 6
            const { children, ...rest } = obj;
            modifiedPlanets.push({
              ...rest,
              ...planetPosition[0][5],
            });
          }
        } 
        else if (levelindex > 5 && total > 6) {
          // overflow → push into 6th object's children
          modifiedPlanets[5].children.push(obj);
        }
      }

      // ===== Special logic for growth stage (index 3) =====
      else if (index === 2 || index === 1 ||  index === 3 ||  index === 4) {
        // if (levelindex < 6) {
        //   position = planetPosition[3][levelindex];
        // } else {
        //   // overflow → push into 6th planet's position
        //   position = planetPosition[3][5];
        // }
        // modifiedPlanets.push(position ? { ...obj, ...position } : obj);
          if (levelindex < 7) {
          // first 5 planets → normal positions
          modifiedPlanets.push({
            ...obj,
            ...planetPosition[index][levelindex],
          });
        } 
        else if (levelindex === 7) {
          // 6th planet → bucket if overflow, else normal
          if (total > 8) {
            modifiedPlanets.push({
              ...obj,
              ...planetPosition[index][7],
              children: [obj],
            });
          } else {
            // remove any pre-existing children if length === 6
            const { children, ...rest } = obj;
            modifiedPlanets.push({
              ...rest,
              ...planetPosition[index][7],
            });
          }

        } 
            else if (levelindex > 7 && total > 8) {
          // overflow → push into 6th object's children
          modifiedPlanets[7].children.push(obj);
        }
      }

      // ===== Random placement for other stages =====
      else {
        let randomIndex =
          index === 1 || index === 2
            ? Math.floor(Math.random() * 8)
            : Math.floor(Math.random() * 6);

        while (selectedIndex.includes(randomIndex)) {
          randomIndex = Math.floor(
            Math.random() * (index === 1 || index === 2 ? 8 : 6)
          );
        }
        selectedIndex.push(randomIndex);

        position = planetPosition[index]?.[randomIndex];
        modifiedPlanets.push(position ? { ...obj, ...position } : obj);
      }
    });

 


    return { ...item, planet: modifiedPlanets };
  });
  
};


export const getPlantLayout=(data:any)=>{
  const layout: any[] = [];
    const conceptStage = data.filter((data:any)=> data.pro_status_id ===1)
  const buildingStage = data.filter((data:any)=> data.pro_status_id ===2)
  const growthStage = data.filter((data:any)=> data.pro_status_id ===3)
  const liveStage = data.filter((data:any)=> data.pro_status_id ===4)
  const deadStage = data.filter((data:any)=> data.pro_status_id ===5)
 
  layout.push(
    { stage: 3, planet:  growthStage },
    { stage: 2, planet: buildingStage },
    { stage: 1, planet:  conceptStage},
    { stage: 4, planet:  liveStage},
    { stage: 5, planet:  deadStage}
  );

  return getPlantPosition(layout);
}
